import React from "react";
import { Grid } from "@mui/material";
import { SellerReview } from "../../../../services/sellerReviews";
import ReviewCard from "./ReviewCard";

interface ReviewsGridProps {
  reviews: SellerReview[];
  onDelete: (id: string) => void;
  onEdit: (reviewId: string, updates: any) => Promise<void>;
}

const ReviewsGrid: React.FC<ReviewsGridProps> = ({ reviews, onDelete, onEdit }) => (
  <Grid container spacing={3}>
    {reviews.map((review) => (
      <Grid key={review.id} size={{ xs: 12, md: 6 }}>
        <ReviewCard review={review} onDelete={onDelete} onEdit={onEdit} />
      </Grid>
    ))}
  </Grid>
);

export default ReviewsGrid;